import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";
import { UpdateProductSetBody } from "./updateProductSet.types";

export const requestUpdateProductSet = async ({
  id,
  ...body
}: UpdateProductSetBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesProductSets.ProductSets, id),
    body
  );
};
